



















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import Invoices from "@/components/subscription/invoices.vue";
import ActiveSubscriptionMessage from "@/components/subscription/messages/active-subscription.vue";
import Subscription from "@/models/subscription";
import User from "@/models/user";

@Component({
  computed: {
    ...mapState("authentication", ["user"]),
    ...mapState("subscriptions", ["subscriptions"]),
    ...mapGetters("subscriptions", [
      "activeSubscription",
      "hasActiveSubscription",
      "hasPausedSubscription",
    ]),
  },
  components: {
    ActiveSubscriptionMessage,
    Invoices,
  },
})
export default class UserSubscription extends Vue {
  // mapState + mapGetters
  user!: User;
  subscriptions!: Array<Subscription>;
  hasActiveSubscription!: boolean;
  hasPausedSubscription!: boolean;
  activeSubscription!: Subscription;

  loading = false;
  activeTab = 0;
}
